import React from 'react';
import { useUser } from '../../context/UserContext';
import { CheckCircleIcon } from 'lucide-react';
interface ProfileSummaryProps {
  onComplete: () => void;
}
const ProfileSummary: React.FC<ProfileSummaryProps> = ({
  onComplete
}) => {
  const {
    userData
  } = useUser();
  return <div data-id="element-368">
      <div className="flex justify-center mb-6" data-id="element-369">
        <CheckCircleIcon size={48} className="text-green-600" data-id="element-370" />
      </div>
      <h2 className="text-2xl font-bold mb-6 text-center text-green-700" data-id="element-371">
        Your Profile Summary
      </h2>
      <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6" data-id="element-372">
        <div className="mb-4" data-id="element-373">
          <h3 className="text-lg font-medium text-green-800 mb-1" data-id="element-374">
            Human Design Type
          </h3>
          <p className="text-gray-700" data-id="element-375">{userData.humanDesignType}</p>
          <p className="text-sm text-gray-600 mt-1" data-id="element-376">
            {userData.humanDesignDescription}
          </p>
        </div>
        <div className="mb-4" data-id="element-377">
          <h3 className="text-lg font-medium text-green-800 mb-1" data-id="element-378">
            Your Authority
          </h3>
          <p className="text-gray-700" data-id="element-379">{userData.humanDesignAuthority}</p>
          <p className="text-sm text-gray-600 mt-1" data-id="element-380">
            {userData.humanDesignAuthorityDescription}
          </p>
        </div>
        <div className="mb-4" data-id="element-381">
          <h3 className="text-lg font-medium text-green-800 mb-1" data-id="element-382">
            Your Top Principles
          </h3>
          <ul className="space-y-1" data-id="element-383">
            {userData.values?.map(value => <li key={value} className="text-gray-700" data-id="element-384">
                <span className="font-medium" data-id="element-385">
                  {value.charAt(0).toUpperCase() + value.slice(1)}
                </span>
                :
                <span className="text-sm ml-1" data-id="element-386">
                  {userData.valueDescriptions?.[value].split(': ')[1]}
                </span>
              </li>)}
          </ul>
        </div>
        <div data-id="element-387">
          <h3 className="text-lg font-medium text-green-800 mb-1" data-id="element-388">Your Goal</h3>
          <p className="text-gray-700" data-id="element-389">{userData.goal}</p>
        </div>
      </div>
      <p className="text-center text-gray-600 mb-6" data-id="element-390">
        Based on your profile, we've personalized your SevenAfter journey.
        You're ready to start restoring your seven sacred gardens!
      </p>
      <button onClick={onComplete} className="bg-green-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-green-700 transition-colors w-full font-medium" data-id="element-391">
        Begin My Journey
      </button>
    </div>;
};
export default ProfileSummary;